import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { FiMenu, FiX } from 'react-icons/fi';
import AdmVertNav from '../../admincomponents/AdminVertNav/AdmVertNav';
import styles from './AdminSettings.module.css'; // optional styling module
import { NavLink, useNavigate } from 'react-router-dom';
import config from '../../config/config';

const AdminSettings = () => {
  const [adminEmail, setAdminEmail] = useState('');
  const [currentPassword, setCurrentPassword] = useState('');
  const [newFullname, setNewFullname] = useState('');
  const [newPassword, setNewPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [message, setMessage] = useState('');
  const [error, setError] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const [mobileNavOpen, setMobileNavOpen] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    const email = localStorage.getItem('adminEmail');
    const name = localStorage.getItem('adminName');
    if (email) setAdminEmail(email);
    if (name) setNewFullname(name); // set current name as default
  }, []);

  const handleUpdate = async (e) => {
    e.preventDefault();
    setMessage('');
    setError('');
    setIsLoading(true);

    if (newPassword && newPassword !== confirmPassword) {
      setIsLoading(false);
      return setError("New passwords don't match");
    }

    try {
      const token = localStorage.getItem('adminToken');

      const res = await axios.post(
        `${config.apiBaseUrl}/api/admin/update-settings`,
        {
          currentPassword,
          newFullname,
          newPassword,
        },
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      setMessage(res.data.message);

      // If name updated, reflect it in localStorage immediately
      if (newFullname) {
        localStorage.setItem('adminName', newFullname);
      }

      // If password updated, log out after short delay
      if (newPassword) {
        setTimeout(() => {
          localStorage.removeItem('adminToken');
          localStorage.removeItem('adminName');
          localStorage.removeItem('adminEmail');
          navigate('/admin/0083/login');
        }, 1500);
      }
    } catch (err) {
      setError(err.response?.data?.message || 'Update failed');
    } finally {
      setIsLoading(false);
    }
  };

  return (
     <div className={styles.settingsContainer}>
       <div className={styles.settingsLeft}>
<button 
        className="products-mobile-nav-toggle"
        onClick={() => setMobileNavOpen(!mobileNavOpen)}
      >
        {mobileNavOpen ? <FiX size={24} /> : <FiMenu size={24} />}
      </button>

      {/* Imported Vertical Navigation */}
      <AdmVertNav 
        mobileNavOpen={mobileNavOpen} 
        closeMobileNav={() => setMobileNavOpen(false)} 
      />

       </div>
    <div className={styles.settingsRight}>
      <div className={styles.card}>
        <div className={styles.header}>
          <h2>Admin Settings</h2>
          <div className={styles.userInfo}>
            <span className={styles.email}>{adminEmail}</span>
            <span className={styles.name}>{newFullname}</span>
          </div>
        </div>
        
        <form onSubmit={handleUpdate} className={styles.settingsForm}>
          <div className={styles.formGroup}>
            <label className={styles.label}>
              Current Password
              <input
                type="password"
                value={currentPassword}
                onChange={(e) => setCurrentPassword(e.target.value)}
                className={styles.input}
                required
                placeholder="Enter current password"
              />
            </label>
 <NavLink to="/admin/0083/forgot-password" >
            Forgot Password ??
          </NavLink>

          </div>

          <div className={styles.formGroup}>
            <label className={styles.label}>
              New Full Name
              <input
                type="text"
                value={newFullname}
                onChange={(e) => setNewFullname(e.target.value)}
                className={styles.input}
                placeholder="Enter new full name"
              />
            </label>
          </div>

          <div className={styles.formGroup}>
            <label className={styles.label}>
              New Password
              <input
                type="password"
                value={newPassword}
                onChange={(e) => setNewPassword(e.target.value)}
                className={styles.input}
                placeholder="Enter new password (optional)"
              />
            </label>
          </div>

          <div className={styles.formGroup}>
            <label className={styles.label}>
              Confirm New Password
              <input
                type="password"
                value={confirmPassword}
                onChange={(e) => setConfirmPassword(e.target.value)}
                className={styles.input}
                placeholder="Confirm new password"
              />
            </label>
          </div>

          <button 
            type="submit" 
            className={styles.submitButton}
            disabled={isLoading}
          >
            {isLoading ? 'Updating...' : 'Update Settings'}
          </button>

          {message && (
            <div className={`${styles.alert} ${styles.success}`}>
              {message}
              {newPassword && <div>You will be logged out shortly...</div>}
            </div>
          )}
          {error && <div className={`${styles.alert} ${styles.error}`}>{error}</div>}
        </form>
      </div>
    </div>
    </div>
  );
};

export default AdminSettings;